import { isDefined } from "@clipboard-health/util-ts";

import { useGetWorkplaceStarredProfessionals } from "./useGetWorkplaceStarredProfessionals";
import { useStarredProfessionalConfiguration } from "./useStarredProfessionalConfiguration";

export function useWorkplaceStarredProfessionals(params: {
  workplaceId?: string;
  workerId?: string;
}) {
  const { workplaceId, workerId } = params;
  const { enabled: isStarredProfessionalEnabled } = useStarredProfessionalConfiguration();

  const {
    data: workplaceStarredProfessionalsResponse,
    isLoading: isLoadingWorkplaceStarredProfessionals,
    isError: isErrorWorkplaceStarredProfessionals,
  } = useGetWorkplaceStarredProfessionals(
    { workplaceId: workplaceId! },
    { enabled: isDefined(workplaceId) && workplaceId !== "" && isStarredProfessionalEnabled }
  );

  const workplaceStarredProfessionals =
    isDefined(workplaceStarredProfessionalsResponse) &&
    !isLoadingWorkplaceStarredProfessionals &&
    !isErrorWorkplaceStarredProfessionals
      ? workplaceStarredProfessionalsResponse.data
      : [];

  const workplaceHasStarredProfessionals = workplaceStarredProfessionals.length > 0;

  const starredProfessionalId = workplaceStarredProfessionals.find(
    (starredProfessional) =>
      isDefined(workerId) && starredProfessional.relationships.worker.data.id === workerId
  )?.id;

  const workplaceStarredProfessionalWorkerIds = workplaceStarredProfessionals.map(
    (starredProfessional) => starredProfessional.relationships.worker.data.id
  );

  return {
    isStarredProfessionalEnabled,
    workplaceHasStarredProfessionals,
    workplaceStarredProfessionalWorkerIds,
    starredProfessionalId,
  };
}
